import { useState } from 'react';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    const formEl = e.currentTarget;
    const formData = new FormData(formEl);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    formData.delete('website_alt');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const res = await fetch('http://cefotiam.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        setErrorMsg(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20football%20trophy%20close%20up%20with%20sparkling%20golden%20particles%20and%20confetti%2C%20dark%20dramatic%20background%20with%20soft%20bokeh%20lights%2C%20championship%20celebration%20atmosphere%2C%20cinematic%20lighting%2C%20luxurious%20gold%20and%20dark%20green%20color%20scheme%2C%20premium%20sports%20photography&width=1920&height=800&seq=cta-bg-wc2026&orientation=landscape"
          alt="2026世界杯订阅"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/80 to-background-950/90"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-background-50 mb-3">
            世界杯资讯 · 快人一步
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-8">
            订阅世界杯资讯推送，赛程、门票、福利活动第一时间送达您的邮箱
          </p>

          {status === 'success' ? (
            <div className="p-6 bg-accent-500/20 border border-accent-500/30 rounded-xl">
              <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 text-accent-400">
                <i className="ri-checkbox-circle-line text-3xl"></i>
              </span>
              <p className="text-accent-300 font-semibold">
                订阅成功！感谢您的关注，精彩资讯即将送达！
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
             
            >
              <div className="honeypot-field">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的邮箱地址"
                required
                className="flex-1 px-5 py-3.5 bg-background-50/10 border border-background-300/30 rounded-full text-sm text-background-50 placeholder:text-background-500 outline-none focus:border-primary-400/60 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold transition-all duration-200 hover:bg-primary-600 disabled:opacity-60 whitespace-nowrap cursor-pointer"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>
          )}

          {status === 'error' && errorMsg && (
            <p className="text-red-400 text-sm mt-3">{errorMsg}</p>
          )}
        </div>
      </div>
    </section>
  );
}